import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useAppDispatch, useAppSelector } from "hooks";
import { nsoFlowFetchData, nsoFlowFetchNsoRequestData } from "../../../../redux/nsoFlow/nsoFlowSlice";
import CommonLoader from "components/CommonLoader";

type PostOrderChangetoSimEngineProps = {
  id: any;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function PostOrderChangetoSimEngine({ id }: PostOrderChangetoSimEngineProps) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const nsoSelectorData = useAppSelector((state) => state.nsoFlow.nsoFlow.data[6].data);

  const [nsoSelector, setNsoSelector] = React.useState<any>(nsoSelectorData);

  const nsoError = useAppSelector((state) => state.errorStep.nsoError);
  const isError = nsoError ? nsoError.step >= 9 : false;
  const isAlreadyFetched =
    nsoSelectorData instanceof Array
      ? false
      : "status" in nsoSelectorData
        ? true
        : nsoSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(nsoFlowFetchData());
      dispatch(nsoFlowFetchNsoRequestData({ id, stepId: 9 }));
    } else {
      setNsoSelector(nsoSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, nsoSelectorData]);

  const nsoSelectorLoading = useAppSelector((state) => state.nsoFlow.nsoFlow.loading);
  // const [responseData] = React.useState<any>(nsoSelector.response_json);
  useEffect(() => {
    // console.log("requestData", nsoSelector);
  }, [nsoSelector]);
  const vehicleIdentifierData: Array<any> = [
    {
      id: 1,
      name: "Request ID",
      value: nsoSelector.request_json?.requestId ?? "",
    },
    {
      id: 2,
      name: "URN",
      value: nsoSelector.request_json?.urn ?? "",
    },
    {
      id: 3,
      name: "RTO ID",
      value: nsoSelector.request_json?.rtoId ?? "",
    },
    {
      id: 4,
      name: "Model No",
      value: nsoSelector.request_json?.modelNo ?? "",
    },
    {
      id: 5,
      name: "Model Year",
      value: nsoSelector.request_json?.modelYear ?? "",
    },
    {
      id: 6,
      name: "Factory Option List",
      value: nsoSelector.request_json?.factoryOptionList ?? "",
    },
    {
      id: 7,
      name: "ILA Option List ",
      value: nsoSelector.request_json?.ilaOptionList ?? "",
    },
  ];

  const colorData: Array<any> = [
    {
      id: 1,
      name: "Exterior",
      value: nsoSelector.request_json?.extColor ?? "",
    },
    {
      id: 2,
      name: "Interior",
      value: nsoSelector.request_json?.intColor ?? "",
    },
  ];

  const renderData: Array<any> = [
    {
      id: 1,
      title: "Change Request to SIM Engine",
      data: vehicleIdentifierData,
    },
    {
      id: 2,
      title: "Color",
      data: colorData,
    },
  ];

  // const specifcationData: Array<any> = [
  //   { id: 1, name: "Spec 200 V1", value: nsoSelector.request_json?.spec200_version_1 },
  //   { id: 2, name: "Spec 200 V2", value: nsoSelector.request_json?.spec200_version_2 },
  // ];
  const spec200v1 = nsoSelector.request_json?.spec200_version_1;
  const spec200v2 = nsoSelector.request_json?.spec200_version_2;
  useEffect(() => {
    // console.log("responseData", responseData);
  }, [nsoSelector]);
  if (nsoSelectorLoading) {
    return <CommonLoader active={nsoSelectorLoading} />;
  }
  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {renderData.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.title}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
              <div className="grid grid-cols-3 m-4 gap-4">
                {item.data.map((items: any) => (
                  <div className="" key={items.id}>
                    <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                      <div className="text-base">{items.name}</div>
                      <div className="text-base break-all">{items.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
          <div className="flex w-full justify-start items-center content-center">
            <span className="font-bold mx-4 text-xl">Specifications</span>
          </div>
          <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
          <div className="grid grid-cols-12 m-4 gap-4">
            <div className="text-base w-fit col-start-1 col-end-3 flex align-items items-center flex flex-col justify-center gap-2 mt-2">
              <div className="">Spec 200 V1</div>
              <div className="">Spec 200 V2</div>
            </div>
            <div className="overflow-x-auto py-2 col-start-3 col-end-12">
              <table className="min-w-full">
                <tr>
                  {spec200v1?.split("").map((item: string, index: number) => {
                    return (
                      <td key={index} className="p-2 w-2  text-center">
                        {index + 1}
                      </td>
                    );
                  })}
                </tr>
                <tr>
                  {spec200v1?.split("").map((item: string, index: number) => {
                    return (
                      <td key={index} className="p-2 w-12  text-center">
                        {item}
                      </td>
                    );
                  })}
                </tr>
                <tr>
                  {spec200v2?.split("").map((item: string, index: number) => {
                    return (
                      <td key={index} className="p-2 w-12  text-center">
                        {item}
                      </td>
                    );
                  })}
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

PostOrderChangetoSimEngine.propTypes = {
  requestData: PropTypes.any,
  responseData: PropTypes.any,
};

export default PostOrderChangetoSimEngine;
